<template>
  <div id="hres82e-reserve" class="hres82e-reserve">
    <div class="hrms-staappr">
      <div class="header-paper clearfix">
        <div class="header-left">
          <div class="box-header-label">
            <div class="header-label-ico"><i class="fa fa-users"></i> {{ labels['HRES82EC3']['10'] }}</div>
            <div class="header-label-data">: {{ indexSelected.roomno }} - {{ indexSelected.desc_roomno }}</div>
          </div>
          <!-- <div class="box-header-label">
            <div class="header-label-ico"><i class="fa fa-calendar"></i> {{ labels['HRES82EC3']['20'] }}</div>
            <div class="header-label-data">: {{ dateSelected }}</div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="box-func">
      <div class="box-topic border-color-skin">
        <i class="fa fa-pencil margin-r-5 color-skin"></i>
        <label class="color-skin">{{ descCodapp }}</label>
      </div>

      <div class="box-body">
        <div class="col-md-12">
          <div class="row">
            <div class="clearfix form-group">
              <label>{{ labels['HRES82EC3']['20'] }}</label>
              <hrms-datepicker  disabled="disabled"
                                v-model="detail.dtereq"
                                name="dtereq" />
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="clearfix form-group">
              <label>{{ labels['HRES82EC3']['30'] }}</label>
              <hrms-datepicker  disabled="disabled"
                                v-model="dateSelected"
                                name="dtereq" />
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="clearfix form-group">
              <label>{{ labels['HRES82EC3']['40'] }}</label>
              <div class="">
                <div class="col-xs-6 clear-padding">
                  <div class="form-group">
                    <label>{{ labels['HRES82EC3']['50'] }} <span class="red">*</span></label>
                    <hrms-timepicker  v-model="detail.timstrt"
                                      v-validate="'required|date_format:HH:mm'"
                                      data-vv-name="timstrt"
                                      data-vv-value-path="inputTime"
                                      name="timstrt"
                                      :class="{ 'input-error' : errors.has('timstrt') }"
                                      :has-error="errors.has('timstrt')"
                                      :disabled="!presentConFlg" />
                    <div class="text-error" v-show="errors.has('timstrt')">{{ errors.first('timstrt') }}</div>
                  </div>
                </div>
                <div class="col-xs-6 clear-padding">
                  <div class="form-group">
                    <label>{{ labels['HRES82EC3']['60'] }} <span class="red">*</span></label>
                    <hrms-timepicker  v-model="detail.timend"
                                      v-validate="'required|date_format:HH:mm'"
                                      data-vv-name="timend"
                                      data-vv-value-path="inputTime"
                                      name="timend"
                                      :class="{ 'input-error' : errors.has('timend') }"
                                      :has-error="errors.has('timend')"
                                      :disabled="!presentConFlg" />
                    <div class="text-error" v-show="errors.has('timend')">{{ errors.first('timend') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="form-group">
              <label>{{ labels['HRES82EC3']['70'] }} <span class="red">*</span></label>
              <div class="row">
                <div class="form-group">
                  <div class="radio col-xs-12">
                    <label>
                      <input  type="radio"
                              value="B"
                              v-model="detail.staappr"
                              :disabled="!presentConFlg">
                      {{ labels['HRES82EC3']['80'] }}
                      <span v-if="(detail.staappr === 'B' || detail.staappr === 'C') && (detail.desc_codempid.trim() !== '')">
                        {{ labels['HRES82EC3']['100'] }} {{ detail.desc_codempid }}
                      </span>
                    </label>
                  </div>
                  <div class="radio col-xs-12">
                    <label>
                      <input  type="radio"
                              value="C"
                              v-model="detail.staappr"
                              :disabled="!presentConFlg">
                      {{ labels['HRES82EC3']['90'] }}
                      <span v-if="(detail.staappr === 'C') && (detail.desc_codappr.trim() !== '')">
                        {{ labels['HRES82EC3']['110'] }} {{ detail.desc_codappr }}
                      </span>
                    </label>
                    <input type="hidden"
                            v-model="detail.staappr"
                            v-validate="'required'"
                            data-vv-name="staappr"
                            :has-error="errors.has('staappr')">
                    <div class="text-error" v-show="errors.has('staappr')">{{ errors.first('staappr') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="form-group">
              <label>{{ labels['HRES82EC3']['120'] }}</label>
              <textarea class="form-control" 
                        v-model="detail.object" 
                        name="object" 
                        id="object" 
                        maxlength="250"
                        v-validate="'max:250'"
                        data-vv-name="object"
                        :disabled="!presentConFlg"
                        :has-error="errors.has('object')" ></textarea>
              <div class="text-error" v-show="errors.has('object')">{{errors.first('object')}}</div>
              <div class="remark-limit-character">{{ dispLimitLabel(250) }}</div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="form-group">
              <label>{{ labels['HRES82EC3']['130'] }}</label>
              <textarea class="form-control" 
                        v-model="detail.remark" 
                        name="remark" 
                        id="remark" 
                        maxlength="250"
                        v-validate="'max:250'"
                        data-vv-name="remark"
                        :disabled="!presentConFlg"
                        :has-error="errors.has('remark')"></textarea>
              <div class="text-error" v-show="errors.has('remark')">{{errors.first('remark')}}</div>
              <div class="remark-limit-character">{{ dispLimitLabel(250) }}</div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="form-group">
              <label>{{ labels['HRES82EC3']['140'] }} <span class="red">*</span></label>
              <div class="input-group">
                  <input  type="number"
                          name="qtypers"
                          id="qtypers"
                          :class="{ 'form-control' : true, 'input-error' : errors.has('qtypers') }"
                          v-model="detail.qtypers"
                          v-validate="'required'"
                          data-vv-name="qtypers"
                          :has-error="errors.has('qtypers')"
                          :disabled="!presentConFlg" />
                  <div class="input-group-addon input-group-addon-cust">{{ labels['HRES82EC3']['150'] }}</div>
              </div>
              <div class="text-error" v-show="errors.has('qtypers')">{{ errors.first('qtypers') }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-footer">
          <!-- Sumit Button -->
          <button type="button" class="btn bg-dark-gray" @click="toggle('detail')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
          <button v-show="presentConFlg" type="button" class="btn bg-color-skin" @click="callSave()"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
          <button v-show="!presentConFlg" type="button" class="btn bg-color-skin" ><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres82e-reserve',
  props: [ 'labels', 'toggle', 'nowLang', 'labelsButton', 'descCodapp', 'dateSelected', 'indexSelected', 'calendarSelected', 'searchIndex', 'detail', 'currentUser', 'reserveYear', 'reserveMonth', 'postHres82eReserveSave', 'presentConFlg' ],
  data () {
    return {
      app: this.$parent.$parent.$parent.$parent
    }
  },
  watch: {
    'detail.timstrt' () {
      this.$validator.validate('timstrt', this.detail.timstrt).catch(e => {})
    },
    'detail.timend' () {
      this.$validator.validate('timend', this.detail.timend).catch(e => {})
    },
    'detail.staappr' () {
      this.$validator.validate('staappr', this.detail.staappr).catch(e => {})
    },
    'detail.qtypers' () {
      this.$validator.validate('qtypers', this.detail.qtypers).catch(e => {})
    },
    'detail.object' () {
      this.$validator.validate('object', this.detail.object).catch(e => {})
    },
    'detail.remark' () {
      this.$validator.validate('remark', this.detail.remark).catch(e => {})
    },
    detail () {
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    saveParams () {
      return {
        roomno: this.indexSelected.roomno,
        dteyear: this.reserveYear,
        dtemonth: this.reserveMonth,
        codempid: this.currentUser,
        dtereserv: this.dateSelected,
        seqno: this.detail.seqno,
        timstrt: this.detail.timstrt,
        timend: this.detail.timend,
        staappr: this.detail.staappr,
        object: this.detail.object,
        remark: this.detail.remark,
        qtypers: this.detail.qtypers
      }
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHres82eReserveSave({ saveParams: this.saveParams(), searchParams: this.searchIndex })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// reserve.vue?61130c5b